export const PROJECTS = [
  {
    slug: "shillong-urban-mobility",
    title: "Shillong Urban Mobility Corridor",
    category: "Infrastructure",
    client: "State Urban Development",
    location: "Shillong, Meghalaya",
    cover: "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=2400",
    gallery: [
      "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=2400",
      "https://images.pexels.com/photos/11310491/pexels-photo-11310491.jpeg?w=2400",
      "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=2400",
    ],
    services: ["DPR Preparation", "Survey & Investigation", "Construction Consultancy"],
    challenges:
      "Steep terrain, fragile slopes and dense urban fabric demanded a low-impact alignment with minimal land take.",
    solutions:
      "LiDAR-driven alignment optimisation, retaining wall engineering and traffic phasing during construction.",
    outcome: "18% reduction in travel time across the corridor and improved pedestrian safety.",
    timeline: "2021 – 2024",
    specs: [
      { k: "Length", v: "12.4 km" },
      { k: "Lanes", v: "4-lane divided" },
      { k: "Cost", v: "₹ 312 Cr" },
    ],
  },
  {
    slug: "guwahati-luxury-resort",
    title: "Riverside Luxury Resort",
    category: "Hospitality",
    client: "Private Sponsor",
    location: "Guwahati, Assam",
    cover: "https://images.unsplash.com/photo-1777245398213-e95bb34c442a?q=85&w=2400",
    gallery: [
      "https://images.unsplash.com/photo-1777245398213-e95bb34c442a?q=85&w=2400",
      "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=2400",
    ],
    services: ["Hospitality Consultancy", "Architecture", "Project Management"],
    challenges:
      "Flood-prone riverside site, sensitive ecology and a brand operator with global FF&E standards.",
    solutions:
      "Elevated plinth, green-rated MEP systems and a phased construction strategy aligned with monsoon cycles.",
    outcome: "120-key, 5-star resort delivered to brand standards with IGBC Gold rating.",
    timeline: "2020 – 2023",
    specs: [
      { k: "Keys", v: "120" },
      { k: "Star", v: "5-star" },
      { k: "Land", v: "9 acres" },
    ],
  },
  {
    slug: "dimapur-retail-mall",
    title: "Dimapur Lifestyle Mall",
    category: "Retail",
    client: "Retail Developer",
    location: "Dimapur, Nagaland",
    cover: "https://images.pexels.com/photos/18206310/pexels-photo-18206310.jpeg?w=2400",
    gallery: [
      "https://images.pexels.com/photos/18206310/pexels-photo-18206310.jpeg?w=2400",
      "https://images.unsplash.com/photo-1614521084980-811d04f6c6cb?q=85&w=2400",
    ],
    services: ["Retail Consultancy", "Architecture", "PMC"],
    challenges:
      "Establishing a contemporary retail destination in a Tier-3 market with limited mall culture.",
    solutions:
      "Catchment-led tenant mix, anchor-led leasing strategy and an outdoor F&B promenade.",
    outcome: "92% leased before opening; weekly footfall of 45,000+.",
    timeline: "2022 – 2024",
    specs: [
      { k: "GLA", v: "320,000 sqft" },
      { k: "Anchors", v: "4" },
      { k: "F&B", v: "18 outlets" },
    ],
  },
  {
    slug: "delhi-cultural-centre",
    title: "Cultural & Convention Centre",
    category: "Cultural",
    client: "Cultural Trust",
    location: "New Delhi",
    cover: "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=2400",
    gallery: [
      "https://images.unsplash.com/photo-1683290844875-0eee4089069a?q=85&w=2400",
    ],
    services: ["Architecture", "Art & Cultural Consultancy", "Structural Design"],
    challenges:
      "Acoustically demanding programs co-located with heritage galleries in a sensitive urban context.",
    solutions:
      "Box-in-box acoustic isolation, daylight-tuned gallery skylights and adaptive reuse of heritage façade.",
    outcome: "1,400-seat auditorium, 8 galleries and a 9,000 sqft convention hall.",
    timeline: "2019 – 2023",
    specs: [
      { k: "Seats", v: "1,400" },
      { k: "Galleries", v: "8" },
      { k: "BUA", v: "180,000 sqft" },
    ],
  },
  {
    slug: "northeast-smart-city",
    title: "Smart City ICCC Implementation",
    category: "Smart City",
    client: "Smart City SPV",
    location: "North East India",
    cover: "https://images.pexels.com/photos/11310491/pexels-photo-11310491.jpeg?w=2400",
    gallery: [
      "https://images.pexels.com/photos/11310491/pexels-photo-11310491.jpeg?w=2400",
    ],
    services: ["DPR", "Project Management", "Monitoring & Evaluation"],
    challenges: "Multi-vendor integration across CCTV, traffic, environment and emergency systems.",
    solutions: "Open API-based ICCC stack with vendor-neutral integration governance.",
    outcome: "ICCC operational with 1,800+ field sensors and 12 integrated departments.",
    timeline: "2020 – 2024",
    specs: [
      { k: "Sensors", v: "1,800+" },
      { k: "Departments", v: "12" },
      { k: "Cost", v: "₹ 245 Cr" },
    ],
  },
  {
    slug: "industrial-park-greenfield",
    title: "Greenfield Industrial Park",
    category: "Industrial",
    client: "State Industrial Corp.",
    location: "Assam",
    cover: "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=2400",
    gallery: [
      "https://images.unsplash.com/photo-1674280325498-accd8919133b?q=85&w=2400",
    ],
    services: ["Master Planning", "Environmental", "DPR"],
    challenges: "Wetland buffer constraints and last-mile connectivity to NH.",
    solutions: "Cluster layout that preserves drainage, plus a 4-lane spur road.",
    outcome: "220-acre park with 38 industrial plots and shared utilities.",
    timeline: "2022 – ongoing",
    specs: [
      { k: "Area", v: "220 acres" },
      { k: "Plots", v: "38" },
    ],
  },
];
